export default "__VITE_ASSET__331925be__"